import { LOCATION_CHANGE } from 'modules/router/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

import * as types from '../../../../actionTypes';

/**
 * Handle start of import for audits or tscans.
 * Adds entity IDs to importing array.
 */
const handleImportAuditsOrTscans = (state, { payload }) => {
  const { ids: entityIds } = payload.request.data;
  return [...state, ...entityIds];
};

/**
 * Handle successful import of audits or tscans.
 * Removes imported IDs from importing array.
 */
const handleImportAuditsOrTscansSuccess = (state, { payload }) => {
  const { importedIds } = payload;
  return state.filter(id => !importedIds.includes(id));
};

/**
 * Handle failed import of audits or tscans.
 * Removes failed entity IDs from importing array if present in meta.
 */
const handleImportAuditsOrTscansFailure = (state, { meta }) => {
  const { entityIds } = meta;
  return entityIds ? state.filter(id => !entityIds.includes(id)) : state;
};

/**
 * Reset importing state to initial.
 */
const resetImporting = () => [];

/**
 * Reducer for tracking which inspections are currently being imported.
 * Stores array of inspection IDs.
 */
export default createReducer([], {
  [types.IMPORT_AUDITS_OR_TSCANS]: handleImportAuditsOrTscans,
  [types.IMPORT_AUDITS_OR_TSCANS_SUCCESS]: handleImportAuditsOrTscansSuccess,
  [types.IMPORT_AUDITS_OR_TSCANS_FAILURE]: handleImportAuditsOrTscansFailure,
  [LOCATION_CHANGE]: resetImporting,
});
